//Добавление удаление данных о просматриваемом в модальном окне ORDERedientDetails ингредиенте.
export const SOME_ORDER_VIEWING = 'SOME_ORDER_SELECTED';
export const SOME_ORDER_VIEWING_CLEAR = 'SOME_ORDER_SELECTED_CLEAR';


